import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const setupWorkingAnimations = (section, setActiveStep) => {
  if (!section) {
    return () => {};
  }

  const ctx = gsap.context(() => {
    // Scroll animations completely removed as requested
  }, section);

  return () => {
    ctx.revert();
  };
};